module.exports = __webpack_public_path__ + "components/flag/static/square/gb-wls-491f82448f66d793ea04276b619edcd0.svg";